import React from 'react';

const ArchDataContext = React.createContext('archData');

export default ArchDataContext;
